/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Organizations functionality

define('modules/UserOrganizations/UserOrganizations.Forms',[], function () {
    'use strict';

    var forms = {
        OrganizationBudget: {

            Fields: [
                {
                    "Name": 'Customer Budget Renew Day of Month',
                    "Field": '#drpBudgetRenewalDay',
                    "Param": 'renewDayOfMonth',
                    "Type": 'Select',
                    "Validators": [{
                        "Type": 'Integer'
                    }, {
                        "Type": 'MinValue',
                        "Value": 1
                    }, {
                        "Type": 'MaxValue',
                        "Value": 31
                    }]
                },
                {
                    "Name": 'Customer Monthly Budget',
                    "Field": '#txtCustomerBudget',
                    "Param": 'budget',
                    "Type": 'Text',
                    "Validators": [
                        {
                            "Type": 'MinValue',
                            "Value": 0
                        }]
                }
            ],
            Validate: true
        }
    };

    return forms;
});

